import React, { useState, useRef, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/joy";
import CustomTypography from "../../../common/CustomTypography";
import { theme } from "styles/theme";
import fivestarsImg from "static/image/onboarding/fivestars_yellow.svg";
import appstoreIconImg from "static/image/payment/appstore_icon.png";
import googleplayIconImg from "static/image/payment/googleplay_icon.png";
import plusIconImg from "static/image/payment/plus_icon_m.svg";

const reviews: ReviewItem[] = [
  {
    source: "Google Play",
    content:
      "처음으로 ‘아 내가 바뀔 수 있겠구나’라고 느끼고, 안전지대가 되어준 서비스 입니다~  정신과 n년, 심리 상담 다수, 뇌파 치료 등 마음 관리에 있어 할 수 있는 건 다 해봤어요. 근데 늘 시간 내는 것도 너무 힘들고, 비용보다도 그 시간을 확보하는 게 더 큰 스트레스였고, 의료진도 생각보다 기계적으로 느껴져서 제 맥락이 크게 중요하게 다뤄지지 않는 느낌이었어요. 그래서 어느 순간 좀 지쳐서 포기 상태였는데, 알아차림·내면소통 명상을 공부하다가 디스턴싱을 알게 됐어요. 처음엔 비용 때문에 긴장도 많이 했는데, 진행할수록 프로그램이 꽤 탄탄하다는 게 느껴졌고 불안도 점점 줄었어요. 무엇보다 텍스트 기반이라 제 성향상 너무 좋았어요. 대면하면 상대 비언어를 너무 신경 써서 오히려 솔직해지기 어려웠는데, 여기선 온전히 저한테만 집중하면서 마음껏 얘기할 수 있는 안전지대가 생긴 느낌이었어요. 아직 진행 중이긴 하지만.. 제 스스로 나아질 수 있다라는 걸 느끼고 자신감이 싹트게 되었어요.",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjU_g8Po66YqHPryEIRlFYlV0KIXupD1TgW8uSOj2aBB8J_3UZ7C",
    name: "달쑥",
    date: "2026-03-17",
  },
  {
    source: "App Store",
    content:
      "인생의 큰 변화중 하나인 결혼과 출산을 겪으며 너무 힘들어서 상담도 해보았는데, 도돌이표 반복이라 병원을 가 약복용이라도 해야할하나 고민 끝에 근본적인 치료를 위해 하고 있는데 점점 머릿속이 정리되는 신기한 경험중입니다.",
    name: "Lee mira",
    date: "2026-03-12",
  },
  {
    source: "App Store",
    content:
      "매번 같은 문제 반복하면서 답답했어요. 언제까지 이렇게 의존해야 삶을 겨우 유지할 수 있는지… 아마 이런 걸로 이거저거 해본 분들이라면 무슨 느낌인지 아실 거예요. 그런데 처음으로 나 스스로 변하는 느낌을 받아요! 쉽진 않긴 한데 그래도 코치 선생님께서 계속 도와주고 격려해주셔서 명상도 기록도 포기하지 않고 하다 보니까, 요즘은 일상 속에서도 이 내용들이 생각나면서 너무 깊은 수렁에 빠지지 않게 될 때도 많아요. 감사합니다 정말로..!",
    name: "연와",
    date: "2026-03-11",
  },
  {
    source: "Google Play",
    content:
      "마스터 플랜 큰맘먹고 신청했는데 일주일해보니 저 자신을 위해 아주 잘 한 선택같아요. 100일 해보고 싶은 마음이 확정됐어요. 나아질거란 기대가 생깁니다.",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjV1XBnwkqA_n2lPF4zLt_opHpfvm2F3VLljbqCHOuYCUKFp2yUW",
    name: "Viva Feliz",
    date: "2026-03-11",
  },
  {
    source: "App Store",
    content:
      "잘 안다고 생각했지만 잘 살피지 못한 마음을 들여다볼 수 있는 소중한 시간을 보낼 수 있게 해주는 고마운 어플입니다. 처음엔 효과가 있을까?하는 생각도 있었지만 그런 생각으로 조금 더 빨리 시작 못한게 아쉬울 정도에요.",
    name: "빵떡빵떡빵",
    date: "2026-03-10",
  },
  {
    source: "Google Play",
    content:
      "팝콘 기계 속에서 팝콘이 튀어오르듯 마음속에서 생각이 예측 불가능하게 튀어오른다는 말이 제게 와닿았고, 디스턴싱 프로그램을 취소하지 않고 계속 듣게 된 계기가 되었습니다. 가뜩이나 힘든 상황인데 문득 떠오르는 부정적인 생각 때문에 더욱 괴로운 순간들이 있습니다. 하지만 이런 부정적인 생각은 내 의도와는 다르게 팝콘 튀기듯 튀어오른 생각이며, 오로지 내 마음 속에서만 벌어지는 사건일 뿐입니다. 내가 떠올린 생각은 외부 상황에 어떠한 영향도 미치지 못하고, 그저 내 마음 속에 떠오르기만 할뿐입니다. 외부의 개입이 아닌, 내 마음 속에서 벌어진 사건으로 인해 내가 힘들어하는 것만큼 손해인 상황은 없을 겁니다. 이런 상황에서 저희가 할 수 있는 일은 그 생각에 휘둘리지 않고, 거리를 두고 생각을 흘려 보내는 것일 겁니다. 디스턴싱 프로그램을 통해 이러한 사실을 깨닫고 현재 생각과 거리두기를 열심히 연습 중입니다. 위에 작성한 글에 동의하는 누군가가 있다면 디스턴싱을 한번 권해보고 싶네요.",
    name: "a a",
    date: "2026-03-10",
  },
  {
    source: "App Store",
    content:
      "저는 한가지 생각이나 걱정이 떠오르면 해결이 될 때까지 끊임 없이 생각을 하는 편입니다. 그것이 스스로를 힘들게 한다는 점은 인식했지만, 생각이 의지에 따라서 안하고 싶다고 안할 수 있는 것이 아니어서 늘 마음이 힘들고 괴로웠습니다. 디스턴싱에서는 이러한 생각이 곧 내가 아님을 알려주고, 관찰자의 입장에서 관찰을 하며 생각과 거리를 둘 수 있는 방법을 알려줍니다. 물론, 아직 프로그램을 진행한지 얼마 되지 않아서 익숙하지는 않고 여전히 생각에 다시 깊게 빠지는 순간들도 많지만, 생각과 거리를 두고 관찰한다는 시각을 한번도 가져보지 못한 저에게는 굉장히 흥미롭기도 하고 나아질 수 있다는 희망이 생겨서 다소 기쁘기도 했던 시간이었습니다. 앞으로도 남은 프로그램들 진행하면서 더 나아질 수 있다고 믿고 꾸준히 진행 하겠습니다!",
    name: "뽀시래기322",
    date: "2026-03-09",
  },
  {
    source: "App Store",
    content:
      "병원에서 약으로 조절 중인데 몇개월이 지나도 일정 수준 이상은 나아지지않아서 시작했어요 해볼만한거같아요 의사 선생님도 요즘 차분해보인다고 하더라고요",
    name: "코옼옼",
    date: "2026-03-04",
  },
  {
    source: "Google Play",
    content:
      "직장생활을 하며 스트레스가 많아서 삶이 조금씩 피폐해지고 있었는데 이걸 교정할 수 있다는 게 좋았다. 휴직을 생각했었는데 디스턴싱으로 훈련을 하면 휴직이라는 선택지가 아니라 더 건강한 선택지를 고를 수 있을 것 같다. 삶에 대한 의지가 더 솟아나는 것 같다.",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjUUU55qVj3qV8X0xyGLHuUyjYyCcQcO1YIgEhr8AdfFwadunMI",
    name: "Avocado_ Yummy",
    date: "2026-03-02",
  },
  {
    source: "Google Play",
    content:
      "육아하면서 마음 관리하기가 어려워 감정에 휩싸이는 순간들이 많았는데, 우연히 알게 된 디스턴싱을 통해서 마음 다스리기 연습 잘 하고 있어요. 큰맘 먹고 지불한 이용권이 아깝지 않습니다. 저처럼 끈기 부족한 사람들도 누구나 꾸준히 할 수 있게 코치 선생님이 챙겨주셔서 좋아요.",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjWNCDrQ98TiDS98ECCPMc8U42Xw_H0HNwNfqc7wp93MiRB5IAyz",
    name: "D Kim",
    date: "2026-02-27",
  },
  {
    source: "Google Play",
    content:
      "평소 꼬리에 꼬리를 무는 생각들이 있었고, 제 감정에 제가 휘둘리는 날이 많았습니다. '디스턴싱'을 시작하고 가장 크게 바뀐 건, 떠오르는 생각들을 사실인 양 믿어버리는 게 아니라 그저 멀리서 관찰하는 법을 배우게 된 거예요. 처음엔 비용이 조금 고민되었지만, 매일 코치님의 피드백을 받으며 제 마음을 글로 정리하다 보니 깊게 저 자신을 이해하게 되었습니다. 저처럼 생각이 너무 많아 스스로를 괴롭히는 분들에게 정말 추천합니다.",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjXx_dNqQ4-DE_N4HK3wZCvu-qZ4H8zN5KLBnb83qAzrCDZMoBg",
    name: "Usereiruw User93or",
    date: "2026-02-25",
  },
  {
    source: "App Store",
    content:
      "디스턴싱이 한 번 궁금해지셨다면 분명 건강해지고픈 의지가 있기 때문이라 생각해요. 그 마음에 귀 기울여보시길 추천드립니다. 정신과 약 끊고 스스로 일어설 수 있는 마음의 근육을 단련시키려 시작했는데 앞으로 얼마나 더 나아질지 기대가 돼요!",
    name: "jellyjuliek",
    date: "2026-02-20",
  },
  {
    source: "App Store",
    content:
      "생각으로부터 거리를 두고 관계를 다시 설정하자라는 말을 듣고 머리가 띵 해졌습니다. 항상 너무 깊게 생각하고 생각에 끌려다니기 때문이었어요. 아직 프로그램 처음 이지만 이 부분에서 도움이 된다고 느껴요. 건강한 마음를 갖는 그날이 기대됩니다.",
    name: "전도ㅑ자",
    date: "2026-02-14",
  },
  {
    source: "App Store",
    content:
      "꼬리에 꼬리를 물고 늘어나는 생각과 감정의 소용돌이에 빠져있을 때 한발자국 물러나 이를 바라볼 수 있는 힘을 길러주는 것 같습니다. 불안과 감정기복 완화에 많은 도움이 되었어요",
    name: "ptnqls3986",
    date: "2026-02-09",
  },
  {
    source: "Google Play",
    content:
      "생각과 나의 관계를 새로 정립해주는 프로그램. 이건 단순히 앱이 아니라 대학병원 치료와 버금가는 치료 프로세스입니다.",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjWIIKw15_OIH9wqe48-nf8ZE3VhUVeM2MUOitu6qSDjR-w6uEjT",
    name: "감성진",
    date: "2026-02-05",
  },
  {
    source: "Google Play",
    content:
      "예전에 정신과도 다녀보고 약도먹어보고 심리상담도 해봤지만 그건 내 푸념이었고 스스로 극복하기위해 디스턴싱이 필요하다는 걸 알았고 직접 기록하고 곱씹고 배우며 이게 내게 필요한 근본적인것이구나 깨달아가고 있어요 정말 좋은 앱이에요",
    avatarImg:
      "https://lh3.googleusercontent.com/a-/ALV-UjXSs9JvnNHq58E0u9jmq83QssZnj5yN7C8NQ059UrSvQ8Ild60",
    name: "행복꽁이(행복이)",
    date: "2026-02-04",
  },
  {
    source: "Google Play",
    content:
      "정말 좋아요. 기대하지 않았는데 참 좋네요. 결제하길 잘했어요. 주변의 다른 사람에게도 추천하고 싶네요.",
    name: "지은",
    date: "2026-01-28",
  },
  {
    source: "App Store",
    content:
      "연말 목표를 이루지못하면 어떡하지, 생각지않은 방향으로 흘러가는 인생으로 스트레스 한껏 받고있었는데 해당앱을 인스타 통해 접하게되어 반신반의 하여 받게되었다 50만원넘게 내고 풀배터리 검사도 받고 했지만 도움은 못받았었으나 이 앱은 스트레스 감정을 어떻게 나와 목표와 실제 분리해서 본질적으로, 장기적으로 해결할수있을지 해결책을 제시하는것 같아 좋다.",
    name: "윤덜니",
    date: "2026-01-26",
  },
  {
    source: "App Store",
    content:
      "어려서부터 ‘생각이 너무 많다’는 말을 들어왔는데, 이 프로그램을 통해 생각의 파트를 분리해보며 정돈되어 가는 듯해요. 그리고 스스로 어느정도 알고있다고 생각한 ‘나’에 대해서도 새롭게 배우고 있어요. 100일동안 같이 훈련하며 무언가 해볼 힘을 다시 길러볼 수 있을 것 같아요.",
    name: "구름으로",
    date: "2026-01-22",
  },
  {
    source: "App Store",
    content:
      "어디에도 기댈 곳이 없고, 털어놓을 곳이 없어서 혼자 버티는 느낌이었어요. 집도 회사도, 모든 인간관계가요. 디스턴싱은 단순히 들어주는 것이 아니라 내가 스스로 놓치고 있던 감정들이나 지점을 코치님이 딱 짚어주십니다. ‘아 내가 이 부분에서 유독 약했구나’ 하고 알게 되는 순간들이 있었어요. 정리되지 않은 마음 그대로 꺼내도 핵심을 짚어주는 디테일한 코칭이 인상적입니다. 혼자 정리하기 어려운 마음을 차분하게 돌아볼 수 있어서 조용한 위로가 되었어요.",
    name: "조용한물멍",
    date: "2026-01-21",
  },
  {
    source: "Google Play",
    content:
      "디스턴싱 앱을 일주일 간 사용해 보니, 그동안 감정 관리에 대해 새로운 인사이트를 얻어가서 좋았어요! 저는 평소에 짜증도 많고 우울한 감정에 자주 휘둘리는 성격이었어요. 그런데 코치님께서 그런 감정들을 잘못됐다고 없애는 것이 아니라 그냥 거리를 두고 알아차리는 것만으로도 마음을 다스리는데 도움이 된다고 하셔서 실천해 보니까 훨씬 마음이 편해졌어요! 제가 정신과도 다녀보고, 심리상담도 받아봤는데 어느 순간 제가 먼저 이야기를 꺼내야 한다는 게 부담이더라고요. 어떤 이야기를 해야 할지 모르겠고, 저조차도 제 감정을 말로 설명하기 어려웠어요. 그런데 하루에 하나씩 활동지를 해나가면서 저에게 맞는 속도로 조금씩 마음에 대해 배워가고 있어서 좋아요. 코치님께서도 제 이야기에 대해 판단하지 않으시고 그저 제 상황에 적절한 도움을 주려고 하시는 것 같아서 마음이 편했어요😊 앞으로 남은 90일동안 제가 얼마나 달라질지 기대돼요. 생각을 나와 분리하는 연습이 필요하신 분께 강추드립니다!!",
    avatarImg:
      "https://play-lh.googleusercontent.com/a-/ALV-UjUaZRItUCyMaaTI4-Zg_SVkmrQQx7w1FyWrV9Fh7Y8CCpZiUXmW",
    name: "슈품",
    date: "2026-01-18",
  },
  {
    source: "App Store",
    content:
      "요 근래 몇년간 마음이 편하질 않아서 뭐라도 해보고싶은 마음에 큰 기대없이 시작했는데, 생각보다 도움이 많이 됩니다. 한발자국씩 천천히 따라갈 수 있는 친절한 설명이 참 좋습니다. 주변에도 추천하고 있어요:)",
    name: "D.G.me.",
    date: "2026-01-13",
  },
  {
    source: "App Store",
    content:
      "정신과 진료보기전에 최후의 방법으로 이용해본 어플. 비용이 부담될 수 있지만 심리적인 안정을 많이 찾았다. 평생 살아가야 하는 인생에서...생각에 휘둘리고 빠져나올 수 없는 고통의 시간들을 조금이라도 줄여주는데 도움이 된다면 그것만으로도 이 어플의 가치는 충분한 것 같다.",
    name: "myeunj",
    date: "2026-01-12",
  },
  {
    source: "App Store",
    content:
      "가격이 비싸지만 그 값을 해요. 더 침착해졌어요. 감정도 되돌아보게 도와주고, 조절하는 방법도 배웠어요. 힘들때 자연스럽게 앱을 켜게 되는 것 같아요",
    name: "수수찡찡",
    date: "2026-01-03",
  },
  {
    source: "Google Play",
    content:
      "최근 나를 더 보살펴야 겠다는 생각으로 디스턴싱을 구매했습니다 사실 저에게는 조금 부담되는 가격이었지만 그래도 나를 위해 한번쯤 소비하자 라는 생각으로 결제하고 약 2-3주정도 진행을 해오고 있는데, 생각보다 도움을 많이 받고 있습니다. 평소 일기를 잘 쓰지 않는 편인데, 매일 생각기록을 하면서 내 감정을 기록하는 습관도 길러지는것 같습니다. 코치님께서 피드백 해주시는 부분도 생각보다 심리적 안정감에 큰 도움이 됩니다. 항상 생각을 스위치 처럼 끄고 킬수 있으면 좋겠다고 생각해온편이었는데, 다른 방식으로 생각과 나를 분리하는 연습을 해보니 새롭습니다.",
    name: "aa A",
    date: "2025-12-28",
  },
  {
    source: "App Store",
    content:
      "디스턴싱을 시작하면서 내 마음에 이전과는 다른 여유가 생기기 시작했다. 예전에는 부정적인 감정이 올라오면 그 감정에 그대로 휩쓸려 스스로를 몰아붙이거나, 감정을 억누르며 버티는 경우가 많았다. 하지만 지금은 그 감정을 ‘나 자신’으로 동일시하기보다 한 걸음 떨어져 바라볼 수 있게 되었다는 점이 가장 큰 변화다. 부정적인 마음이 들 때마다 그것을 외면하지 않고 기록하고, 그 감정이 왜 생겼는지, 어떤 생각에서 비롯된 것인지를 코칭을 통해 차분히 들여다보는 시간이 도움이 많이 되었다. 그 과정은 마치 마음속에 쌓아두었던 이야기들을 대나무숲에 털어놓는 것처럼 솔직하고 후련한 경험이었다. 누군가에게 이해받고 정리된 언어로 되돌려 받으면서 감정의 무게가 자연스럽게 가벼워지는 느낌을 자주 받았다. 특히 좋았던 점은 부정적인 감정이 생겼을 때 그것을 없애려 애쓰기보다, ‘아, 지금 이런 마음이 올라오고 있구나’ 하고 있는 그대로 인정할 수 있게 되었다는 것이다. 그 덕분에 감정에 끌려 반응하기보다 나에게 조금 더 친절한 선택을 할 수 있는 여지가 생겼다. 이제는 예전보다 나 자신을 더 믿게 되었고, 앞으로의 나에 대한 기대감도 커졌다. 완벽해지지 않아도 괜찮고, 흔들리더라도 다시 중심을 찾을 수 있다는 안정감이 마음 깊은 곳에 자리 잡아가고 있다. 건강한 정신과 마음으로 살아갈 나의 시간이 이미 시작되었고, 그 앞으로의 과정이 조용히, 그러나 분명하게 기다려진다.",
    name: "회원니임",
    date: "2025-12-22",
  },
  {
    source: "App Store",
    content:
      "나의 상황과 생각들을 되돌아 볼 수 있는 획기적인 도구이며 매우 편리합니다. 처음 이 앱을 결제하고 사용할때까진 회의적인 편이었지만 직관적이고 꾸밈없는 질문들에 점점 더 대답하기 수월해지고 마음이 편해지며 생각들이 정리 되는 것을 느끼실 겁니다. 요즘 우울감이 많이 커져서 정신 과의 도움을 받고자 했었는데 병원을 알아봐도 초진은 기본 3주는 기다려야 했었고 그 상황마다 좌절하고 더 깊은 우울감에 빠져 결국 병원 진료를 포기하게 됐었습니다. 그러다 이 앱을 발견하여 시작해 봤는데 아직은 초기 단계지만 마음이 힘들때나 나의 감정들을 돌아보고 싶을때 사용할 수 있는 도구가 있다는 것에 든든합니다. 나와 가까운 친구나 가족이 아닌 타인에게 나의 얘기를 할수있고 전문적인 도움도 함께 받을 수 있어 좋습니다. 앞으로 더 꾸준히 사용해 볼 예정입니다.",
    name: "Prinnceesss",
    date: "2025-12-20",
  },
  {
    source: "Google Play",
    content:
      "직장생활에 마음이 너무 힘들어서 도움을 받고싶어 가입했는데, 제상황을 객관적으로 벽에 붙여놓듯 바라볼 수있게 도와준 프로그램인것같아요 현재는 조금씩 마음이 힘들었던게 나아지고있고, 남은 프로그램은 직장뿐아니라 개인적인 영역도 함께 코칭을 받아보고싶은 마음이있어요.",
    avatarImg:
      "https://play-lh.googleusercontent.com/a-/ALV-UjUBLiVd794z1EzPMTJJM5NJ-JtGAUory5HKjUHTk8P57srZioHc",
    name: "고현경",
    date: "2025-12-16",
  },
  {
    source: "App Store",
    content:
      "바로바로 저에게 도움이 되고 효과가 나타나서 정말 놀랍습니다. 불안이나 두려움 과거 기억에 사로잡혀있다면 추천합니다.",
    name: "가루가메",
    date: "2025-11-25",
  },
  {
    source: "Google Play",
    content:
      "디스턴싱을 통해 확실히 마음이 더 차분해지고 감정이나 생각에 얽매여 시간을 쓰거나 괴롭지 않게 됐어요. 앞으로의 배움도 기대돼요 ㅎㅎ 이런 서비스를 만들어주셔서 진심으로 감사해요!!",
    name: "anything",
    date: "2025-11-18",
  },
  {
    source: "App Store",
    content:
      "디스턴싱을 시작하고 처음으로 내가 하는 생각이 얼마나 임의적인데 매번 휘둘리고 괴로워했나 자각했습니다. 조금더 연습해서 나의 평화로운 모습만 되찾아나간다면 새로운 나에게 닻을 내릴수 있으리라는 희망이 생깁니다.",
    name: "헤라마미",
    date: "2025-10-19",
  },
];

export interface ReviewItem {
  source: "App Store" | "Google Play";
  content: string;
  avatarImg?: string;
  name: string;
  date: string;
}

interface ReviewSectionProps {
  initialDisplayCount?: number;
  incrementCount?: number;
  maxContentLength?: number;
}

const ReviewCard = ({ review }: { review: ReviewItem }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const sourceIcon =
    review.source === "App Store" ? appstoreIconImg : googleplayIconImg;

  // Get first character of name for avatar fallback
  const avatarInitial = review.name.charAt(0);

  // Format date from "YYYY-MM-DD" to "YYYY.MM.DD."
  const formattedDate = review.date.replace(/-/g, ".") + ".";

  // Check if content overflows 5 lines
  useEffect(() => {
    if (contentRef.current) {
      const element = contentRef.current;
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [review.content]);

  return (
    <Stack spacing={"20px"} alignItems="center" sx={{ width: "100%" }}>
      {/* 5 Stars */}
      <Box sx={{ height: "24px", width: "124px" }}>
        <img
          src={fivestarsImg}
          alt="5 stars"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Review Content */}
      <Stack sx={{ width: "100%", maxWidth: "660px", px: "4px" }}>
        <Box>
          <Typography
            ref={contentRef}
            variant="Body"
            sx={{
              fontWeight: 500,
              color: theme.vars.palette.Content.Medium,
              textAlign: "center",
              display: "-webkit-box",
              WebkitLineClamp: isExpanded ? "unset" : 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "keep-all",
            }}
          >
            {review.content}
          </Typography>
          {isOverflowing && (
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant={"Body"}
                onClick={() => setIsExpanded(!isExpanded)}
                sx={{
                  py: 0,
                  fontWeight: 500,
                  color: theme.vars.palette.Content.Highlight,
                  cursor: "pointer",
                }}
              >
                {!isExpanded && "더 보기"}
              </Typography>
            </Box>
          )}
        </Box>
      </Stack>

      {/* User Info */}
      <Stack direction="row" spacing={"8px"} alignItems="center">
        {/* Avatar with Source Icon */}
        <Box sx={{ position: "relative", width: "32px", height: "32px" }}>
          {review.avatarImg ? (
            <Box
              sx={{
                width: "32px",
                height: "32px",
                borderRadius: "100px",
                overflow: "hidden",
                border: `1px solid rgba(32, 39, 43, 0.04)`,
              }}
            >
              <img
                src={review.avatarImg}
                alt={review.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                width: "32px",
                height: "32px",
                borderRadius: "100px",
                backgroundColor: theme.vars.palette.Content.SuperWeak,
                border: `1px solid rgba(32, 39, 43, 0.04)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant={"Subtitle"}
                sx={{
                  fontWeight: 500,
                  color: theme.vars.palette.Content.Negative,
                }}
              >
                {avatarInitial}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              position: "absolute",
              right: "-3px",
              bottom: "-3px",
              width: "16px",
              height: "16px",
              borderRadius: "5px",
              overflow: "hidden",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={sourceIcon}
              alt={review.source}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {/* Name and Date */}
        <Stack>
          <Typography
            variant={"Caption"}
            sx={{
              fontWeight: 500,
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {review.name}
          </Typography>
          <Typography
            variant={"Footnote"}
            sx={{
              fontWeight: 400,
              color: theme.vars.palette.Content.Weak,
            }}
          >
            {formattedDate}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default function ReviewSection({
  initialDisplayCount = 3,
  incrementCount = 3,
}: ReviewSectionProps) {
  const [displayCount, setDisplayCount] = useState(initialDisplayCount);

  const visibleReviews = reviews.slice(0, displayCount);
  const hasMore = displayCount < reviews.length;

  const handleShowMore = () => {
    setDisplayCount((prev) => Math.min(prev + incrementCount, reviews.length));
  };

  return (
    <Stack
      spacing={"40px"}
      alignItems="center"
      sx={{
        backgroundColor: theme.vars.palette.Background.Level1,
        width: "100%",
        px: "36px",
        py: "80px",
      }}
    >
      {/* Title */}
      <CustomTypography
        variant="H2"
        sx={{
          fontWeight: 700,
          color: theme.vars.palette.Content.Strong,
          textAlign: "center",
        }}
      >
        {"1000+개의 5점 후기가\n" + "증명하는 효과"}
      </CustomTypography>

      {/* Review Cards */}
      {visibleReviews.map((review, index) => (
        <ReviewCard key={index} review={review} />
      ))}

      {/* Show More Button */}
      {hasMore && (
        <Button
          variant="Outlined"
          color={"primary"}
          size="md"
          onClick={handleShowMore}
          startDecorator={
            <img
              src={plusIconImg}
              alt="plus"
              style={{ width: "20px", height: "20px" }}
            />
          }
          sx={{
            "--Button-gap": "4px",
            fontWeight: 700,
            maxWidth: "660px",
            width: "100%",
            height: "48px",
            boxShadow: `inset 0 0 0 1.4px ${theme.vars.palette.Border.Highlight}`,
          }}
        >
          더 많은 후기 보기
        </Button>
      )}
    </Stack>
  );
}
